'use client';

import { c as _c } from "react/compiler-runtime";
import type { Data } from '@repo/strapi-types';
import { useMemo, useState } from 'react';
import { Container } from '@/components/elementary/Container';
import { BillingSwitch } from '@/components/page-builder/global/pricingV1/BillingSwitch';
import { FeatureComparison } from '@/components/page-builder/global/pricingV1/featureComparison';
import { FeaturedPlan } from '@/components/page-builder/global/pricingV1/featuredPlan';
import { PlanOverview } from '@/components/page-builder/global/pricingV1/overview';
import { MONTHLY_VISIBLE_PLANS } from '@/constants/pricing.constants';
export function PricingClient(t0) {
  const $ = _c(31);
  const {
    data,
    stickyTopOffset,
    billingSwitchTagImage,
    billingSwitchArrowImage,
    featuredPlan,
    anchorId,
    dataTestId
  } = t0;
  const [yearly, setYearly] = useState(true);
  let t1;
  if ($[0] !== data) {
    t1 = data?.find(_temp)?.title ?? data?.[0]?.title ?? "";
    $[0] = data;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [currentTab, setCurrentTab] = useState(t1);
  let t2;
  bb0: {
    if (!data) {
      t2 = data;
      break bb0;
    }
    let t3;
    if ($[2] !== data || $[3] !== yearly) {
      t3 = yearly ? data : data.slice(0, MONTHLY_VISIBLE_PLANS);
      $[2] = data;
      $[3] = yearly;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    t2 = t3;
  }
  const visibleData = t2;
  let t3;
  if ($[5] !== featuredPlan) {
    t3 = featuredPlan && <FeaturedPlan data={featuredPlan} />;
    $[5] = featuredPlan;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== billingSwitchArrowImage || $[8] !== billingSwitchTagImage || $[9] !== currentTab || $[10] !== data || $[11] !== yearly) {
    t4 = <BillingSwitch data={data} yearly={yearly} setYearly={setYearly} currentTab={currentTab} setCurrentTab={setCurrentTab} tagImage={billingSwitchTagImage} arrowImage={billingSwitchArrowImage} />;
    $[7] = billingSwitchArrowImage;
    $[8] = billingSwitchTagImage;
    $[9] = currentTab;
    $[10] = data;
    $[11] = yearly;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== currentTab || $[14] !== stickyTopOffset || $[15] !== visibleData || $[16] !== yearly) {
    t5 = <PlanOverview data={visibleData} yearly={yearly} currentTab={currentTab} setCurrentTab={setCurrentTab} stickyTopOffset={stickyTopOffset} />;
    $[13] = currentTab;
    $[14] = stickyTopOffset;
    $[15] = visibleData;
    $[16] = yearly;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== currentTab || $[19] !== visibleData || $[20] !== yearly) {
    t6 = <FeatureComparison data={visibleData} yearly={yearly} currentTab={currentTab} setCurrentTab={setCurrentTab} />;
    $[18] = currentTab;
    $[19] = visibleData;
    $[20] = yearly;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== t4 || $[23] !== t5 || $[24] !== t6) {
    t7 = <div className="pt-11.25 pb-22.5 bg-brand-black"><Container paddingX={true}>{t4}{t5}{t6}</Container></div>;
    $[22] = t4;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  let t8;
  if ($[26] !== anchorId || $[27] !== dataTestId || $[28] !== t3 || $[29] !== t7) {
    t8 = <div id={anchorId} data-test-id={dataTestId}>{t3}{t7}</div>;
    $[26] = anchorId;
    $[27] = dataTestId;
    $[28] = t3;
    $[29] = t7;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  return t8;
}
function _temp(plan) {
  return plan?.mostPopular;
}